module.exports = __webpack_public_path__ + "img/fdkeji.abfbb618.jpg";